<template>
  <form class="row" @submit.prevent="submit">
    <div class="medium-12 columns image-field">
      <label>
        {{ $t('AGENT_BOT_MANAGEMENT.FORM.FIELDS.IMAGE') }}
      </label>

      <div class="avatar-upload" @click="triggerFileInput">
        <img :src="previewImage" class="avatar-preview" />
      </div>

      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        @change="handleFileUpload"
        hidden
      />
    </div>

    <div class="medium-12 columns">
      <label :class="{ error: $v.name.$error }">
        {{ $t('AGENT_BOT_MANAGEMENT.FORM.FIELDS.NAME') }}
        <input
          v-model.trim="name"
          type="text"
          maxlength="60"
          :placeholder="$t('AGENT_BOT_MANAGEMENT.FORM.PLACEHOLDERS.NAME')"
          @input="$v.name.$touch"
        />
      </label>
    </div>

    <div class="medium-12 columns">
      <label :class="{ error: $v.description.$error }">
        {{ $t('AGENT_BOT_MANAGEMENT.FORM.FIELDS.DESCRIPTION') }}
        <input
          v-model.trim="description"
          type="text"
          maxlength="200"
          :placeholder="
            $t('AGENT_BOT_MANAGEMENT.FORM.PLACEHOLDERS.DESCRIPTION')
          "
          @input="$v.description.$touch"
        />
      </label>
    </div>

    <div class="medium-12 columns">
      <label :class="{ error: $v.webhookUrl.$error }">
        {{ $t('AGENT_BOT_MANAGEMENT.FORM.FIELDS.WEBHOOK') }}
        <input
          v-model.trim="webhookUrl"
          type="text"
          :placeholder="
            $t('AGENT_BOT_MANAGEMENT.FORM.PLACEHOLDERS.WEBHOOK')
          "
          @input="$v.webhookUrl.$touch"
        />
      </label>
    </div>
    <div class="medium-12 columns">
      <label>
        <input
          v-model="message_buffer"
          type="checkbox"
          value="message_buffer"
          name="message_buffer"
        />
        {{ $t('AGENT_BOT_MANAGEMENT.FORM.FIELDS.MESSAGE_BUFFER') }}
      </label>
    </div>

    <div class="modal-footer">
      <div class="medium-12 columns">
        <woot-button type="submit" class="button primary"
          :disabled="$v.$invalid || isSubmitting"
            :is-loading="isSubmitting"
          >
          {{ value.id ? $t('AGENT_BOT_MANAGEMENT.EDIT.SUBMIT') : $t('AGENT_BOT_MANAGEMENT.ADD.SUBMIT') }}
        </woot-button>
        <button class="button clear" @click.prevent="onClose">
          {{ $t('AGENT_BOT_MANAGEMENT.FORM.CANCEL') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators';

const url = helpers.regex(
  'url',
  /^(https?:\/\/)([\w.-]+)+(:\d+)?(\/([\w/_-]*(\?\S+)?)?)?$/
);

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      description: '',
      webhookUrl: '',
      avatar: null,
      previewImage: '/assets/administrate/bot/avatar.png',
      message_buffer: false,
    };
  },
  validations: {
    name: { required },
    description: { required },
    webhookUrl: { required, url },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.avatar = file;
        this.previewImage = URL.createObjectURL(file);
      }
    },

    submit() {

      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;

      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('description', this.description);
      formData.append('outgoing_url', this.webhookUrl);
      formData.append('bot_type', 'webhook');
      formData.append('bot_config', JSON.stringify({}));
      formData.append('message_buffer', this.message_buffer ? '1' : '0');

      if (this.avatar) {
        formData.append('avatar', this.avatar);
      }

      this.$emit('submit', formData);
    },
  },
  mounted() {
    if(this.value.id){      
      const value = JSON.parse(JSON.stringify(this.value));      
      this.name = value.name || '';
      this.description = value.description || '';
      this.webhookUrl = value.outgoing_url || '';
      this.previewImage = value.avatar_url || '/assets/administrate/bot/avatar.png';
      this.message_buffer = value.message_buffer || false;
    }
  },
};
</script>

<style scoped>
.image-field {
  margin-bottom: 16px;
}

.avatar-upload {
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 6px;
}

.avatar-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

select {
  width: 100%;
  height: auto;
}
</style>
